import { render, staticRenderFns } from "./PortalChatStep.vue?vue&type=template&id=5866341a"
import script from "./PortalChatStep.vue?vue&type=script&lang=js"
export * from "./PortalChatStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports